import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import 'angular2-notifications';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'iconify-icon';
import '@angular/compiler';

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function () { };
    window.console.warn = function () { };
    window.console.error = function () { };
    window.console.time = function () { };
    window.console.timeEnd = function () { };
  }
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
